import { render, staticRenderFns } from "./branchs.vue?vue&type=template&id=000f2420&"
import script from "./branchs.vue?vue&type=script&lang=js&"
export * from "./branchs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports